// src/pages/RegisterPage.js
import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import Footer from '../components/Footer';
import logo from '../assets/icons/iconoGestionEJP.png';

const RegisterPage = () => {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const { register, isAuthenticated } = useAuth();
    const navigate = useNavigate();

    // Si ya está autenticado, redirigir al home interno
    if (isAuthenticated) {
        return <Navigate to="/home" replace />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }
        if (!nombre || !email || !password) {
            setError('Todos los campos son obligatorios.');
            return;
        }
        setError('');
        try {
            await register(nombre, email, password);
            setSuccess(true);
            setTimeout(() => {
                navigate("/login", { 
                    state: { 
                        message: 'Registro exitoso. Por favor espera a que un administrador valide tu cuenta para poder iniciar sesión.' 
                    }
                });
            }, 3000);
        } catch (err) {
            setError('Error al registrar. El email ya podría estar en uso.');
            console.error(err);
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <style>{`
                .pub-nav-tabs { position: absolute; left: 50%; transform: translateX(-50%); display: flex; align-items: center; gap: 0.25rem; }
                .pub-nav-title { display: inline; }
                .pub-nav-login-text { display: inline; }
                .pub-nav-login-icon { display: none; }
                .register-grid { display: grid; grid-template-columns: 1fr 1fr; max-width: 1000px; width: 100%; background: white; border-radius: 20px; box-shadow: 0 8px 32px rgba(0,0,0,0.1); overflow: hidden; }
                .register-illustration { background: #f8f9fa; padding: 3rem; display: flex; flex-direction: column; align-items: center; justify-content: center; position: relative; }
                .register-form-col { padding: 3rem; display: flex; flex-direction: column; justify-content: center; }
                @media (max-width: 768px) {
                    .pub-nav-tabs { position: static; transform: none; left: auto; }
                    .pub-nav-title { display: none; }
                    .pub-nav-mobile-title { display: inline !important; }
                    .pub-nav-login-text { display: none; }
                    .pub-nav-login-icon { display: inline; }
                    .register-grid { grid-template-columns: 1fr; }
                    .register-illustration { display: none; }
                    .register-form-col { padding: 2rem 1.5rem; }
                }
            `}</style>
            {/* ===== NAVBAR PÚBLICO ===== */}
            <nav style={{
                position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1100, height: '70px',
                background: 'var(--primary)',
                boxShadow: 'var(--shadow-md)',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1.5rem',
            }}>
                <button
                    onClick={() => navigate('/')}
                    style={{
                        background: 'none', border: 'none', cursor: 'pointer', color: 'white',
                        fontWeight: 600, fontSize: '1.15rem', fontFamily: "'Inter', 'Segoe UI', sans-serif",
                        display: 'flex', alignItems: 'center', gap: '0.6rem', letterSpacing: '0.3px', padding: 0,
                        flexShrink: 0,
                    }}
                >
                    <span className="pub-nav-title">Estudio Jurídico Previsional</span>
                    <span className="pub-nav-mobile-title" style={{ display: 'none' }}>GestiónEJP</span>
                </button>
                {/* Tabs centrados */}
                <div className="pub-nav-tabs">
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            background: 'none', border: 'none', borderBottom: '2px solid transparent',
                            padding: '0.5rem 1rem', fontSize: '0.9rem', fontWeight: 400,
                            color: 'rgba(255,255,255,0.75)', cursor: 'pointer', transition: 'all 0.2s ease',
                            display: 'flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap', height: '70px',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.color = 'white'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}
                    >
                        <i className="bi bi-house-door"></i>
                        Inicio
                    </button>
                    <button
                        onClick={() => navigate('/', { state: { seccion: 'nosotros' } })}
                        style={{
                            background: 'none', border: 'none', borderBottom: '2px solid transparent',
                            padding: '0.5rem 1rem', fontSize: '0.9rem', fontWeight: 400,
                            color: 'rgba(255,255,255,0.75)', cursor: 'pointer', transition: 'all 0.2s ease',
                            display: 'flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap', height: '70px',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.color = 'white'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}
                    >
                        <i className="bi bi-info-circle"></i>
                        Sobre Nosotros
                    </button>
                </div>
                <button
                    onClick={() => navigate('/login')}
                    style={{
                        background: 'rgba(255,255,255,0.15)', border: '1.5px solid rgba(255,255,255,0.6)',
                        borderRadius: '8px', padding: '0.45rem 1.1rem', color: 'white', fontWeight: 600,
                        fontSize: '0.9rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem',
                        transition: 'all 0.2s ease', fontFamily: "'Inter', 'Segoe UI', sans-serif", flexShrink: 0,
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.3)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
                >
                    <i className="bi bi-box-arrow-in-right pub-nav-login-icon"></i>
                    <span className="pub-nav-login-text">Iniciar Sesión</span>
                </button>
            </nav>

            <div style={{ background: "var(--bg-page)", flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "1.5rem", paddingTop: "70px", paddingBottom: "2rem" }}>
                <div className="register-grid">
                    {/* Columna ilustración */}
                    <div className="register-illustration">
                        <div style={{marginBottom: "2rem"}}>
                            <img src={logo} alt="Logo de GestiónEJP" style={{width: "280px", height: "auto", display: "block"}} />
                        </div>
                        <h2 style={{
                            fontSize: "1.5rem",
                            fontWeight: 600,
                            textAlign: "center",
                            color: "#2c3e50",
                            margin: 0
                        }}>
                            Gestión de Trámites Previsionales
                        </h2>
                    </div>

                    {/* Columna formulario */}
                    <div className="register-form-col">
                        <div style={{marginBottom: "1.5rem"}}>
                            <h3 style={{
                                fontSize: "1.75rem",
                                fontWeight: 700,
                                color: "#1e293b",
                                marginBottom: "0.5rem"
                            }}>
                                Crear Usuario
                            </h3>
                            <p style={{
                                color: "#64748b",
                                fontSize: "0.95rem"
                            }}>
                                Regístrate para acceder al sistema
                            </p>
                        </div>
                        
                        <form onSubmit={handleSubmit}>
                            {/* Nombre */}
                            <div style={{marginBottom: "1.25rem"}}>
                                <label style={{
                                    display: "block",
                                    fontWeight: 600,
                                    color: "#374151",
                                    marginBottom: "0.5rem",
                                    fontSize: "0.9rem"
                                }}>
                                    <i className="bi bi-person me-2" style={{color: "#3B82F6"}}></i>
                                    Nombre
                                </label>
                                <input
                                    type="text"
                                    placeholder="Ingresa tu nombre completo"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    required
                                    style={{ width: "100%",
                                        padding: "0.75rem 1rem",
                                        border: "2px solid #e5e7eb",  
                                        transition: "all 0.2s ease",
                                        outline: "none" }}
                                    onFocus={(e) => e.target.style.border = "2px solid #3B82F6"}
                                    onBlur={(e) => e.target.style.border = "2px solid #e5e7eb"}
                                />
                            </div>

                            {/* Email */}
                            <div style={{marginBottom: "1.25rem"}}>
                                <label style={{
                                    display: "block",
                                    fontWeight: 600,
                                    color: "#374151",
                                    marginBottom: "0.5rem",
                                    fontSize: "0.9rem"
                                }}>
                                    <i className="bi bi-envelope me-2" style={{color: "#3B82F6"}}></i>
                                    Email
                                </label>
                                <input
                                    type="email"
                                    placeholder="ejemplo@estudio.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    style={{ width: "100%",
                                        padding: "0.75rem 1rem",
                                        border: "2px solid #e5e7eb",  
                                        transition: "all 0.2s ease",
                                        outline: "none" }}
                                    onFocus={(e) => e.target.style.border = "2px solid #3B82F6"}
                                    onBlur={(e) => e.target.style.border = "2px solid #e5e7eb"}
                                />
                            </div>

                            {/* Password */}
                            <div style={{marginBottom: "1.25rem"}}>
                                <label style={{
                                    display: "block",
                                    fontWeight: 600,
                                    color: "#374151",
                                    marginBottom: "0.5rem",
                                    fontSize: "0.9rem"
                                }}>
                                    <i className="bi bi-lock me-2" style={{color: "#3B82F6"}}></i>
                                    Contraseña
                                </label>
                                <input
                                    type="password"
                                    placeholder="Crea una contraseña segura"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    style={{ width: "100%",
                                        padding: "0.75rem 1rem",
                                        border: "2px solid #e5e7eb",  
                                        transition: "all 0.2s ease",
                                        outline: "none" }}
                                    onFocus={(e) => e.target.style.border = "2px solid #3B82F6"}
                                    onBlur={(e) => e.target.style.border = "2px solid #e5e7eb"}
                                />
                            </div>

                            {/* Confirmar Password */}
                            <div style={{marginBottom: "1.25rem"}}>
                                <label style={{
                                    display: "block",
                                    fontWeight: 600,
                                    color: "#374151",
                                    marginBottom: "0.5rem",
                                    fontSize: "0.9rem"
                                }}>
                                    <i className="bi bi-lock me-2" style={{color: "#3B82F6"}}></i>
                                    Confirmar Contraseña
                                </label>
                                <input
                                    type="password"
                                    placeholder="Vuelve a escribir la contraseña"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    style={{ width: "100%",
                                        padding: "0.75rem 1rem",
                                        border: "2px solid #e5e7eb",  
                                        transition: "all 0.2s ease",
                                        outline: "none" }}
                                    onFocus={(e) => e.target.style.border = "2px solid #3B82F6"}
                                    onBlur={(e) => e.target.style.border = "2px solid #e5e7eb"}
                                />
                            </div>

                            {error && (
                                <div style={{
                                    background: "#FEF2F2",
                                    border: "2px solid #FCA5A5",
                                    color: "#991B1B",
                                    padding: "0.875rem",
                                    borderRadius: "10px",
                                    marginBottom: "1.25rem",
                                    fontSize: "0.9rem"
                                }}>
                                    <i className="bi bi-exclamation-triangle me-2"></i>
                                    {error}
                                </div>
                            )}
                            
                            {success && (
                                <div style={{
                                    background: "var(--gradient-success)",
                                    color: "white",
                                    padding: "1rem",
                                    borderRadius: "10px",
                                    marginBottom: "1.25rem",
                                    fontSize: "0.9rem"
                                }}>
                                    <strong style={{display: "block", marginBottom: "0.25rem"}}>✓ ¡Registro exitoso!</strong>
                                    Tu cuenta ha sido creada. Un administrador debe validar tu usuario antes de que puedas iniciar sesión.
                                    Serás redirigido al inicio de sesión en unos segundos...
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={success}
                                style={{
                                    width: "100%",
                                    padding: "0.875rem",
                                    background: success ? "#9ca3af" : "var(--primary)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "10px",
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    cursor: success ? "not-allowed" : "pointer",
                                    transition: "all 0.2s ease",
                                    boxShadow: success ? "none" : "0 4px 12px rgba(59, 130, 246, 0.3)"
                                }}
                                onMouseEnter={(e) => {
                                    if (!success) {
                                        e.target.style.transform = "translateY(-2px)";
                                        e.target.style.boxShadow = "0 6px 16px rgba(59, 130, 246, 0.4)";
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!success) {
                                        e.target.style.transform = "translateY(0)";
                                        e.target.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.3)";
                                    }
                                }}
                            >
                                <i className="bi bi-person-plus me-2"></i>
                                {success ? 'Registro Exitoso...' : 'Registrarse'}
                            </button>
                        </form>

                        <div style={{
                            textAlign: "center",
                            marginTop: "1.5rem",
                            paddingTop: "1.5rem",
                            borderTop: "1px solid #e5e7eb"
                        }}>
                            <Link to="/login" style={{
                                color: "#3B82F6",
                                textDecoration: "none",
                                fontWeight: 500,
                                fontSize: "0.9rem"
                            }}>
                                <i className="bi bi-box-arrow-in-right me-2"></i>
                                ¿Ya tienes un usuario? Inicia Sesión
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default RegisterPage;
